/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kn_Health_DownInputs */

const cs_kn_health_down = /** @type {(inputs: Kn_Health_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Služba nedostupná`)
};

const en_kn_health_down = /** @type {(inputs: Kn_Health_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service unavailable`)
};

/**
* | output |
* | --- |
* | "Service unavailable" |
*
* @param {Kn_Health_DownInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const kn_health_down = /** @type {((inputs?: Kn_Health_DownInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kn_Health_DownInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kn_health_down(inputs)
	return cs_kn_health_down(inputs)
});